module.exports = __webpack_public_path__ + "static/media/slideMobile02.bac89356.jpg";